export default function SectionCards() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-accent-600 tracking-wider uppercase mb-3 whitespace-nowrap">
            Hot Stories
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
            热门爆料速递
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="lg:col-span-2 lg:row-span-2 bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-300/60 cursor-pointer">
            <div className="aspect-[16/9] overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20illustration%20of%20entertainment%20scandal%20breaking%20news%2C%20paparazzi%20flash%20abstract%2C%20red%20carpet%20with%20dramatic%20lighting%2C%20warm%20crimson%20and%20gold%20accents%2C%20pop%20art%20comic%20style%2C%20spotlight%20and%20shadow%20play%2C%20megaphone%20silhouette%2C%20no%20text%2C%20bold%20composition&width=900&height=500&seq=mrds-cards-01&orientation=landscape"
                alt="独家：某知名女星婚变内幕，知情人士透露细节"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
            <div className="p-5 md:p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-600 whitespace-nowrap">独家爆料</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">2小时前</span>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2">
                独家：某知名女星婚变内幕，知情人士透露细节
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                据多位圈内人士证实，两人已分居数月。知情者向每日大赛mrds独家披露了婚姻破裂的关键原因，涉及第三方介入及财产纠纷。
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-eye-line"></i> 312万
                </span>
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-chat-3-line"></i> 4.8万
                </span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 cursor-pointer">
            <div className="aspect-[4/3] overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20live%20streaming%20drama%2C%20smartphone%20screen%20with%20explosive%20content%2C%20vibrant%20red%20and%20gold%20pop%20art%20style%2C%20social%20media%20notification%20bursts%2C%20dramatic%20lighting%2C%20entertainment%20news%20theme%2C%20no%20text&width=640&height=480&seq=mrds-cards-02&orientation=landscape"
                alt="带货翻车？某大主播直播间言论引发全网抵制"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">热议</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">5小时前</span>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                带货翻车？某大主播直播间言论引发全网抵制
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-eye-line"></i> 189万
                </span>
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-chat-3-line"></i> 3.2万
                </span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-300/60 cursor-pointer">
            <div className="aspect-[4/3] overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20music%20industry%20controversy%2C%20vinyl%20record%20breaking%20in%20half%2C%20dramatic%20red%20and%20dark%20color%20scheme%2C%20musical%20notes%20scattered%2C%20pop%20art%20aesthetic%2C%20entertainment%20scandal%20theme%2C%20no%20text%2C%20bold%20graphic&width=640&height=480&seq=mrds-cards-03&orientation=landscape"
                alt="新歌疑似抄袭？两首热单音轨对比引发争议"
                className="w-full h-full object-cover object-center"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-600 whitespace-nowrap">争议</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">8小时前</span>
              </div>
              <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                新歌疑似抄袭？两首热单音轨对比引发争议
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-eye-line"></i> 145万
                </span>
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-chat-3-line"></i> 2.1万
                </span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-accent-300/60 cursor-pointer">
            <div className="flex flex-col sm:flex-row h-full">
              <div className="sm:w-2/5 aspect-[4/3] sm:aspect-auto overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20film%20industry%20box%20office%20dispute%2C%20movie%20ticket%20with%20cracks%2C%20warm%20red%20and%20gold%20pop%20art%20style%2C%20dramatic%20composition%2C%20entertainment%20news%20theme%2C%20no%20text%2C%20clean%20modern%20design&width=400&height=300&seq=mrds-cards-04&orientation=landscape"
                  alt="票房大战：暑期档两部大片导演隔空互怼"
                  className="w-full h-full object-cover object-center"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className="sm:w-3/5 p-4 flex flex-col justify-center">
                <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700 mb-2 inline-block w-fit whitespace-nowrap">PK</span>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                  票房大战：暑期档两部大片导演隔空互怼
                </h3>
                <span className="text-xs text-foreground-400 whitespace-nowrap">12小时前 · 98万阅读</span>
              </div>
            </div>
          </div>

          <div className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 transition-all duration-300 hover:border-primary-300/60 cursor-pointer">
            <div className="flex flex-col sm:flex-row h-full">
              <div className="sm:w-2/5 aspect-[4/3] sm:aspect-auto overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20reality%20show%20behind%20the%20scenes%2C%20TV%20camera%20with%20cracks%20and%20leaks%2C%20warm%20crimson%20pop%20art%20style%2C%20dramatic%20shadow%20play%2C%20entertainment%20theme%2C%20no%20text%2C%20bold%20graphic&width=400&height=300&seq=mrds-cards-05&orientation=landscape"
                  alt="真人秀剧本曝光：那些年我们被骗的名场面"
                  className="w-full h-full object-cover object-center"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className="sm:w-3/5 p-4 flex flex-col justify-center">
                <span className="px-2 py-0.5 rounded text-xs font-medium bg-primary-100 text-primary-600 mb-2 inline-block w-fit whitespace-nowrap">深挖</span>
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">
                  真人秀剧本曝光：那些年我们被骗的名场面
                </h3>
                <span className="text-xs text-foreground-400 whitespace-nowrap">1天前 · 67万阅读</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}